export enum REVALIDATE_MODES {
  ON_CHANGE = 'onChange',
  ON_BLUR = 'onBlur',
  ON_SUBMIT = 'onSubmit',
  ALL = 'all',
}
